import React, { useEffect, useState } from "react";
import Layout from "../../components/layout";
import { FaArrowLeft } from "react-icons/fa";

import styles from "./JobworkDetailsPage.module.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import { route } from "../../static/route";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  fetchJobworkDetailsData,
  getJobworkDetails,
} from "../../features/jobworkDetails/jobworkDetailsSlice";
import { FaFilePdf } from "react-icons/fa6";
import moment from "moment";
import { POST } from "../../services/axios.service";

const JobworkDetailsPage = () => {
  const { jobworkId, typeId } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const jobwork = useAppSelector(getJobworkDetails);

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleGoToBack = () => {
    navigate(-1);
  };

  const handlePrintReport = async () => {
    setErrorMessage(null);
    try {
      await POST(`/v1/worker/jobworks-reports`, {
        jobwork_ids: [jobwork?.id],
      })
        .then(async (response: any) => {
          if (response.data.status === "success") {
            const downloadLink = response.data.data.download_link;
            try {
              const newWindow = window.open(downloadLink, "_blank");
              if (
                !newWindow ||
                newWindow.closed ||
                typeof newWindow.closed == "undefined"
              ) {
                throw new Error("પોપ્અપ બ્લોક કરેલ છે.");
              }
            } catch (e) {
              window.location.href = downloadLink;
            }
          } else {
            setErrorMessage(response.data.message);
          }
        })
        .catch((error: any) => {
          setErrorMessage(error.data.message);
        });
    } catch (error) {
      setErrorMessage("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.");
    }
  };

  useEffect(() => {
    if (jobworkId)
      dispatch(fetchJobworkDetailsData({ jobworkId: parseInt(jobworkId) }));
  }, [jobworkId]);

  return (
    <Layout className="print:max-h-[148mm]">
      <div className={styles.JobworkDetailsPage}>
        <div className="w-full px-10 h-[200px] text-center flex flex-col justify-center relative">
          <FaArrowLeft
            onClick={handleGoToBack}
            className="absolute top-5 left-5 text-3xl text-white border-2 border-white p-1 rounded-full"
          />

          <h1 className="text-4xl mt-6 font-bold text-white">
            {typeId === "1" ? "બાંધવાના કામ ની વિગત" : "ખોલવાના કામ ની વિગત"}
          </h1>
        </div>

        <div className="w-full relative mt-[70px] px-10 py-5 lg:mt-[20px]">
          {jobwork && jobwork.id ? (
            <div className="w-full p-6 bg-primary-2 bg-opacity-50 rounded-xl shadow mb-5">
              <h5 className="text-primary-1 text-lg font-semibold">
                કામ નું આઇડી : {jobwork.id}
              </h5>

              <div className="flex flex-col gap-3 mt-5">
                <p className="text-primary-1 text-sm font-semibold">
                  પાર્ટી :{" "}
                  {jobwork.party.name +
                    (jobwork.party.phone
                      ? " (" + jobwork.party.phone + ")"
                      : "")}
                </p>
                <p className="text-primary-1 text-sm font-semibold">
                  આઈટમ : {jobwork.item.name}
                </p>
                <p className="text-primary-1 text-sm font-semibold">
                  ટાઇપ : {jobwork.type === 1 ? "ખોલવા આપેલ" : "બાંધવા આપેલ"}
                </p>
                <p className="text-primary-1 text-sm font-semibold">
                  આઈટમ નો વજન : {jobwork.i_weight}
                </p>
                {jobwork.type === 0 && (
                  <p className="text-primary-1 text-sm font-semibold">
                    તાર નો વજન : {jobwork.t_weight}
                  </p>
                )}
                {jobwork.status === 1 && (
                  <>
                    <p className="text-primary-1 text-sm font-semibold">
                      ડિલિવર કરેલ વજન : {jobwork.i_delivered_weight}
                    </p>

                    <p className="text-primary-1 text-sm font-semibold">
                      ડિલિવર કરેલ તારીખ :{" "}
                      {moment(
                        jobwork.delivered_date,
                        "YYYY-MM-DD HH:mm:ss"
                      ).format("DD-MM-YYYY hh:mm A")}
                    </p>
                  </>
                )}
                <p className="text-primary-1 text-sm font-semibold">
                  માલ ની પાર્ટીઓ :{" "}
                  {jobwork?.order_parties?.map((order_party, index) => (
                    <span key={order_party.id}>
                      {index > 0 && ", "}
                      {order_party.party.firm_name +
                        (order_party.party.phone
                          ? " (" + order_party.party.phone + ")"
                          : "")}
                    </span>
                  ))}
                </p>
              </div>

              <div className="w-full flex flex-col">
                <button
                  className="mx-auto flex gap-3 mt-6 shadow disabled:opacity-50 rounded-3xl text-3xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
                  type="button"
                  onClick={handlePrintReport}
                >
                  <FaFilePdf className="text-white mt-1" />
                  PDF
                </button>
                {errorMessage && (
                  <p className="text-red-500 text-sm font-semibold text-center">
                    {errorMessage}
                  </p>
                )}
              </div>
            </div>
          ) : (
            <div className="text-center">
              <p className="mt-4 text-primary-2 font-bold text-2xl">
                કામ ની વિગતો મળી નથી.
              </p>

              <div className="w-full flex justify-center">
                <Link to={route.dashboard}>
                  <button
                    type="button"
                    className="mx-auto mt-8 shadow rounded-3xl text-3xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
                  >
                    કામ ઉમેરો
                  </button>
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};
export default JobworkDetailsPage;
